import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Query } from 'react-apollo'
import { Loader } from '../components'
import messages from '../constants/messages'
import { SINGLE_REPORT_QUERY } from '../constants/queries'
import ResizableTable from '../components/ShootersTable/ResizableTable'
import LoadMore from '../components/LoadMore'
import { ErrorTemplate, LoadingTemplate } from '../Middleware/ResponseMiddleware'
import Message from '../views/Message'

class ShootersTable extends Component {
  static propTypes = {
    organizationId: PropTypes.string,
    componentsTree: PropTypes.object,
    postsLimit: PropTypes.number,
  }

  static defaultProps = {
    postsLimit: 20,
  }

  state = {
    canLoadMore: true,
    postsLimit: this.props.postsLimit,
  }
  isNewLoading = true

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.organizationId !== this.props.organizationId) {
      this.setState({
        canLoadMore: true,
      })
    }
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    if (nextProps.organizationId !== this.props.organizationId) {
      this.isNewLoading = true
    }
  }

  resolveComponent = (organizationGroup1Id, organizationGroup2Id = null) => {
    if (!this.props.componentsTree.hasOwnProperty(organizationGroup1Id)) {
      return this.props.componentsTree.default
    }

    if (!this.props.componentsTree[organizationGroup1Id].hasOwnProperty(organizationGroup2Id)) {
      return this.props.componentsTree[organizationGroup1Id].default
    }

    return this.props.componentsTree[organizationGroup1Id][organizationGroup2Id]
  }

  load = (fetchMore, data) => {
    return fetchMore({
      variables: {
        offset: data.getReport.ranks.length,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult.getReport.ranks.length) {
          this.setState({
            canLoadMore: false,
          })
          return prev
        }

        if (fetchMoreResult.getReport.ranks.length < this.state.postsLimit) {
          this.setState({
            canLoadMore: false,
          })
        }

        return {
          ...data,
          getReport: {
            ...data.getReport,
            ranks: [...data.getReport.ranks, ...fetchMoreResult.getReport.ranks],
          },
        }
      },
    })
  }

  render() {
    const { organizationId } = this.props
    const { canLoadMore, postsLimit } = this.state

    return (
      <Query
        query={SINGLE_REPORT_QUERY}
        variables={{
          organizationId,
          limit: postsLimit,
          offset: 0,
        }}
        fetchPolicy="cache-and-network"
      >
        {({ loading, error, data, fetchMore }) => {
          if (loading && this.isNewLoading) {
            return <LoadingTemplate />
          }

          this.isNewLoading = false

          if (error) {
            return ErrorTemplate(error)
          }

          if (!data.getReport) {
            return <Message text={messages.refineSearch} />
          }

          const shooters = data.getReport.ranks

          if (!shooters.length) {
            return <Message text={messages.nothingFound} />
          }

          const Component = this.resolveComponent(
            data.getReport.organizationGroup1Id,
            data.getReport.organizationGroup2Id
          )

          return (
            <>
              <LoadMore onLoadMore={() => this.load(fetchMore, data)} isLoadingMore={loading} canLoadMore={canLoadMore}>
                <ResizableTable
                  updateParameters={{
                    organizationId,
                  }}
                >
                  <Component data={data} />
                </ResizableTable>
                {this.state.loadingMore && <Loader />}
              </LoadMore>
            </>
          )
        }}
      </Query>
    )
  }
}

export default ShootersTable
